<template>
  <div class="wound-healing q-w360 q-fit">
    <question-with-error-wrap :error="getFieldsError(['prolongedHealingTime'])">
      <single-answer-question
        title="label.myWoundHealing"
        :value="prolongedHealingTime"
        :options="$options.responseOptions"
        hint="info.woundHealing"
        yes-no
        two-columns
        @input="onFieldChange('prolongedHealingTime', $event)"
      />
    </question-with-error-wrap>
  </div>
</template>

<script>
import SingleAnswerQuestion from '@/modules/questionnaire/new-design-components/questions/SingleAnswerQuestion';
import QuestionWithErrorWrap from '@/modules/questionnaire/new-design-components/questions/QuestionWithErrorWrap';

import { stepTemplateMixin } from '@/modules/questionnaire/mixins/stepTemplateMixin';

import { YES_NO_RESPONSE_OPTIONS } from '@/modules/questionnaire/constants/questions';

export default {
  name: 'WoundHealingTemplate',
  components: { QuestionWithErrorWrap, SingleAnswerQuestion },
  responseOptions: YES_NO_RESPONSE_OPTIONS,
  mixins: [stepTemplateMixin],
  props: {
    prolongedHealingTime: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped></style>
